<nz-skeleton [nzActive]="true" [nzLoading]="isLoading || isCRUD" [nzParagraph]="{ rows: 2 }">
  <div class="filter filter-wrap">
    @for (filters of filter; track filters; let filterIdx = $index) {
      <div class="filter-lvl" [class]="filters.length > 1 ? 'filter-box' : ''">
        @for (orFilter of filters; track $index) {
          <div class="and">+</div>
          <div class="filter-box filter-wrap">
            @for (item of orFilter|keyvalue; track $index) {
              <div class="filter-name">{{mappings.get(item.key)}}: </div>
              @for (value of item.value; track $index) {
                <nz-tag class="filter-tag" [nzMode]="disabled ? 'default' : 'closeable'" (nzOnClose)="deleteFilter($event, value, item.key, filterIdx)">{{value}}</nz-tag>
              }
            }
            @if(filters.length == 1 && !disabled) {
              <button nz-button nzType="primary" nzDanger (click)="createFilterModal(addFilter, addFilterFooter, filterIdx)">
                <span nz-icon nzType="plus" nzTheme="outline"></span>
              </button>
            }
          </div>
        }
        @if(filters.length != 1 && !disabled) {
          <button nz-button nzType="primary" nzDanger (click)="createFilterModal(addFilter, addFilterFooter, filterIdx)">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
          </button>
        }
      </div>
      <div class="or">Or</div>
    }
    @if (!disabled) {
      <button class="or" nz-button nzType="primary" nzSize="large" nzDanger (click)="createFilterModal(addFilter, addFilterFooter)">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
        Filter
      </button>
    }
  </div>
</nz-skeleton>

<ng-template #addFilter let-ref="modalRef">
  <div *ngIf="selectedProp?.key == 'ordering_partner_group_id'">
    <p class="warning-text">⚠️ Each "ordering partner group ID" has its own remark fields. Once this ID is selected, this tenant sees the remark fields of that ordering partner group ID.</p>
    <p class="warning-text">⚠️ Once more than one "ordering partner group ID" is used for the same tenant, the remark fields of both IDs are shown merged together.</p>
  </div>
  <form nz-form>
    <nz-form-item>
      <nz-form-label nzRequired>Filter property</nz-form-label>
      <nz-form-control>
        <nz-select
          name="filterKey"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select property"
          (ngModelChange)="selectFilterProp($event, ref)"
          [compareWith]="compareFn"
          [nzFilterOption]="nzFilterOption"
          [(ngModel)]="selectedProp"
        >
          @for (item of mappings | keyvalue: zero; track $index) {
          <nz-option nzCustomContent [nzLabel]="item.value" [nzValue]="item">
            <div class="mapping-option-item">
              <span nz-typography>{{item.value}}</span>
              <span nz-typography nzType="secondary">{{item.key}}</span>
            </div>
          </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    @if (draft && selectedProp) {
    <nz-form-label>Filter data</nz-form-label>
    <div class="filter-box filter-wrap">
      <div class="filter-box-label" style="padding-right: 6px">
        {{ selectedProp.value }}:
      </div>
      @for (item of draft[selectedProp.key]; track $index) {
      <nz-tag
        class="filter-tag"
        [nzMode]="'closeable'"
        (nzOnClose)="deleteFilter($event, item)"
        >{{ item }}</nz-tag>
      }
    </div>
    <nz-form-item>
      <nz-form-label nzRequired>Filter value</nz-form-label>
      <nz-form-control>
        <nz-input-group nzSearch [nzAddOnAfter]="addInput">
          <input nz-input name="addFilterValue" #input />
        </nz-input-group>
        <ng-template #addInput>
          <button
            nz-button
            nzType="default"
            [disabled]="!input.value"
            (click)="addFilterValue(input)"
          >
            <span nz-icon nzType="plus"></span>
          </button>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    }
  </form>
</ng-template>
<ng-template #addFilterFooter let-ref="modalRef">
  <button nz-button (click)="closeModal(ref)">Cancel</button>
  <button
    nz-button
    [nzLoading]="isCRUD"
    [disabled]="isDisabled()"
    (click)="saveFilter(ref)"
    nzType="primary"
    nzDanger
  >
    Add filter
  </button>
</ng-template>
